/**
 * §5.3 — the between-questions screen.
 *
 * docs/ux-mockup.html's idle phone: one icon, one sentence, and nothing to do.
 * The footer standing sits below it, so the player always has their score.
 */

export interface WaitingScreenProps {
  title: string;
  message: string;
  icon?: string;
}

export function WaitingScreen({
  title,
  message,
  icon = "⏳",
}: WaitingScreenProps): React.ReactElement {
  return (
    <div className="tq-phone-idle">
      <div className="tq-phone-idle-icon" aria-hidden="true">
        {icon}
      </div>
      <p className="tq-phone-idle-text">
        <b>{title}</b>
        <br />
        {message}
      </p>
    </div>
  );
}
